import cloneDeep from 'lodash/cloneDeep';

export class AgeVerificationUtility {
  constructor(data) {
    this.data = cloneDeep(data);
  }

  createDateOfBirth() {
    if (this.data.year && this.data.month && this.data.day) {
      this.data.date_of_birth = [
        this.data.year,
        this.data.month,
        this.data.day,
      ].join('-');
    }

    return this;
  }

  coerceAddressState() {
    if (
      typeof this.data.state === 'object' &&
      this.data.state.value !== undefined
    ) {
      this.data.state = this.data.state.value;
    }

    return this;
  }

  value() {
    return this.data;
  }
}
